import Typography from "@mui/material/Typography";
import * as React from "react";
import {Box, Button, useTheme} from "@mui/material";
import {observer} from "mobx-react";
import AddIcon from "@mui/icons-material/Add";

function ArticleFormSection({title, children, feature}) {
    const theme = useTheme();
    const style = styles(theme)

    return (
        <Box component="section" sx={style.formSectionContainer}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
            }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="h3" sx={style.formSectionTitle}>{title}</Typography>
                </Box>
                {feature.canEditArticles() && feature.hasArticlePriceList() &&
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => feature.addArticle()}
                            startIcon={<AddIcon/>}
                        >
                            Agregar Artículo
                        </Button>
                    </Box>
                }
            </Box>
            {children}
        </Box>
    )
}

export default observer(ArticleFormSection)

const styles = (theme) => ({
    formSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: 'inherit',
        padding: '1rem',
        backgroundColor: theme.brand.field,
        borderRadius: '20px',
        marginBottom: '2rem',
    },
    formSectionTitle: {
        fontSize: '1rem',
        margin: '.8em 0'
    }
})
